import { AppState } from '~/providers'

export default () => Boolean(useState(AppState.IsBot).value)
